<template>
    <div>
        <TableInformation1 :leftDescriptionTable="leftDescriptionTable" :rightDescriptionTable="rightDescriptionTable"></TableInformation1>
        <div class="table-responsive mb-2">
            <table class="table table-sm table-bordered">
                <thead>
                    <tr>
                        <th scope="col" class="text-center font-weight-bold">No</th>
                        <th scope="col" class="text-center font-weight-bold">
                            <div class="form-group form-check">
                                <input 
                                    v-model="checkAll" 
                                    @change="toggleCheckAll" 
                                    type="checkbox" 
                                    class="form-check-input custom-checkbox-lg" 
                                    :id="`check-all`"
                                >
                            </div>
                        </th>
                        <th scope="col" class="text-center font-weight-bold">MATERIAL</th>
                        <th scope="col" class="text-center font-weight-bold">DESCRIPTION</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold">Select Data</th>
                        <th scope="col" class="text-center font-weight-bold">Selected Value</th>
                        <th scope="col" class="text-center font-weight-bold">Keterangan</th>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in localItems" :key="index">
                    <tr>
                        <th scope="row" class="py-1 align-middle text-center">{{ index + 1 }}</th>
                        <td class="text-center py-1 align-middle">
                             <div class="form-group form-check">
                                <input 
                                    type="checkbox" 
                                    class="form-check-input custom-checkbox-lg mt-1" 
                                    :id="`check-${item.id}`"
                                    v-model="checkedItems"
                                    :value="item.id"
                                    @change="onItemChange"
                                >
                            </div>
                        </td>
                        <td class="text-center py-1 align-middle">{{ item?.material_code }}</td>
                        <td class="py-1 align-middle">{{ item?.material_description }}</td>
                        <td class="text-center py-1 align-middle">{{ item?.abc_indicator }}</td>
                        <td class="text-center py-1 align-middle">{{ item?.abc_indicator_calculate }}</td>
                        <td class="text-center py-1 align-middle">
                            <select 
                                class="form-control select-custom-size text-center" 
                                :class="item.selected_abc_indicator_bg"
                                v-model="item.selected_abc_indicator" 
                                @change="selectedValue(item, $event)"
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                                <option value="other">Other value</option>
                            </select>
                        </td>
                        <td class="text-center py-1 align-middle">
                            <input 
                                type="text" 
                                class="form-control select-custom-size text-center" 
                                v-model="item.abc_indicator_result"
                                :disabled="item.selected_abc_indicator != 'other'"
                                @change="handleChangeResult"
                            />
                        </td>
                        <td class="text-center py-1 align-middle">
                            <input 
                                type="text" 
                                class="form-control select-custom-size text-center" 
                                v-model="item.description_abc_indicator"
                                @change="handleChangeDesc"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import TableInformation1 from './TableInformation1.vue';

export default {
    name: 'StockCalcTable1',
    components: {
        TableInformation1
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            localItems: JSON.parse(JSON.stringify(this.items)),
            leftDescriptionTable: [{lable: 'Existing', bg: 'bg-grey'},{lable: 'Calculator Recomendation', bg: 'bg-light-yellow'}],
            rightDescriptionTable: [],
            checkAll: false,
            checkedItems: []
        }
    },
    methods: {
        formatTanggal(value) {
            if (!value) return '-';
            return moment(value).format('D MMMM YYYY');
        },
        toggleCheckAll() {
            if (this.checkAll) {
                this.checkedItems = this.localItems.map(item => item.id)
                this.updateItemByCheck(null, 'yes')
            } else {
                this.checkedItems = []
                this.updateItemByCheck(null, 'no')
            }
        },
        onItemChange(e) {            
            e.target.checked ? this.updateItemByCheck(e.target.value, 'yes') : this.updateItemByCheck(e.target.value, 'no')
            this.checkAll = this.checkedItems.length === this.items.length
        },
        updateItemByCheck(id, flag = 'yes') {
            if (flag == 'yes') {
                this.localItems = this.localItems.map(item => (item.id == id || id == null) ? {
                    ... item,
                    selected_abc_indicator: 'yes',
                    selected_abc_indicator_bg: 'bg-light-green',
                    abc_indicator_result: item.abc_indicator_calculate
                } : item)
            } else {
                this.localItems = this.localItems.map(item => (item.id == id || id == null) ? {
                    ... item,
                    selected_abc_indicator: '',
                    selected_abc_indicator_bg: '',
                    abc_indicator_result: ''
                } : item)
            }
            this.$emit('selected-abc-indicator', this.localItems)
        },
        selectedValue(item, e) {
            const value = e.target.value
            
            if (value == 'yes') {
                item.selected_abc_indicator_bg = 'bg-light-green'
                item.abc_indicator_result = item.abc_indicator_calculate
            } else if (value == 'no') {
                item.abc_indicator_result = item.abc_indicator
                item.selected_abc_indicator_bg = 'bg-light-red'
            } else if (value == 'other') {
                item.selected_abc_indicator_bg = 'bg-light-blue'
                item.abc_indicator_result = ''
            }

            if (value != 'yes') {
                this.checkedItems = this.checkedItems.filter(value => value != item.id)
                this.checkAll = this.checkedItems.length === this.items.length
            }

            const item_updated = item;
            this.localItems = this.localItems.map(item => item.id == item_updated.id ? item_updated : item)
            this.$emit('selected-abc-indicator', this.localItems)
        },
        handleChangeResult() {
            this.$emit('selected-abc-indicator', this.localItems)
        },
        handleChangeDesc() {
            this.$emit('selected-abc-indicator', this.localItems)
        }
    }
}
</script>

<style>
    .select-custom-size {
  height: 28px; /* atur sesuai kebutuhan */
  font-size: 0.85rem;
  padding: 0px 0px!important;
}

input.form-check-input.custom-checkbox-lg {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

</style>